import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'icon-document',
  templateUrl: './icon-document.component.html',
  styles: []
})
export class IconDocumentComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
